import { createRoot, hydrateRoot } from 'react-dom/client';
import { App } from './App';
import './styles/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Application root is missing');
const app = <App path={window.location.pathname} />;
if (root.childElementCount) hydrateRoot(root, app);
else createRoot(root).render(app);
